import { FormBase } from 'core/components';

export default class NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name:'emergencySupplyDays',
                    label: 'FACILITY.EDIT.EMERGENCY_SUPPLY_DAYS_LABEL',
                    placeholder: 'FACILITY.EDIT.EMERGENCY_SUPPLY_DAYS_PLACEHOLDER',
                    type: 'integer'
                }
            ],
        };
    }
}
